// Shopify's theme preview bar (previews only) covers whatever is fixed to the bottom of the
// screen, such as the cookie banner. Publish its height so those can sit above it.
(() => {
  const publish = () => {
    const bar = document.getElementById('PBarNextFrame') || document.getElementById('PBarNextFrameWrapper');
    // The frame is full-screen and draws its bar inside (cross-origin, so its real height can't be
    // read): use the measured height only when it is a bar, otherwise the bar's usual 64px.
    const measured = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    const height = !bar ? 0 : measured > 0 && measured < 160 ? measured : 64;
    document.documentElement.style.setProperty('--ldj-preview-bar', `${height}px`);
    return bar;
  };
  let tries = 0;
  const timer = setInterval(() => {
    const bar = publish();
    tries += 1;
    if (bar && window.ResizeObserver) {
      new ResizeObserver(publish).observe(bar);
      clearInterval(timer);
    } else if (tries > 12) {
      clearInterval(timer);
    }
  }, 500);
})();

/* Footer (sections/footer.liquid).
   Below 990px each link group becomes a disclosure: its heading turns into a
   button, groups start closed and any number can be open. From 990px they
   are plain headings over open lists. Without JavaScript every list stays
   open. The shipping country updates as soon as it is chosen. */
// Country check for testing on real devices: add ?ldj-debug=country to any page link.
// Shows what Shopify used for this page (address, theme, country, currency, cookies, bag,
// detected location) in a panel that can be copied. Nothing shows without the parameter,
// and the parameter survives a country change (the form returns to the same URL).
(() => {
  if (!/[?&]ldj-debug=country(?:&|$)/.test(window.location.search)) return;
  const all = (name) => (document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`, 'g')) || [])
    .map((part) => part.split('=').slice(1).join('=')).join(' + ') || 'none';
  const ua = navigator.userAgent;
  const browser = /FBAN|FBAV|Instagram|Line\/|WhatsApp|GSA\//.test(ua) ? 'In-app browser'
    : /CriOS/.test(ua) ? 'Chrome (iPhone)' : /EdgiOS|EdgA/.test(ua) ? 'Edge'
    : /Android/.test(ua) ? (/SamsungBrowser/.test(ua) ? 'Samsung Internet' : 'Chrome (Android)')
    : /iPhone|iPad/.test(ua) ? 'Safari (iPhone)' : /Safari/.test(ua) && !/Chrome/.test(ua) ? 'Safari' : 'Chrome/other';
  const shop = window.Shopify || {};
  const rows = [
    ['Address', `${window.location.host}${window.location.pathname}`],
    ['Theme', shop.theme ? `${shop.theme.name} (${shop.theme.role}, ${shop.theme.id})` : 'unknown'],
    ['Page priced for', `${shop.country || '?'} · ${(shop.currency && shop.currency.active) || '?'} (rate ${(shop.currency && shop.currency.rate) || '?'})`],
    ['Country cookie', all('localization')],
    ['Cart currency cookie', all('cart_currency')],
    ['Footer shows', (document.querySelector('[data-footer-country-value]') || {}).textContent?.trim() || 'no selector'],
    ['Browser', `${browser}${navigator.cookieEnabled ? '' : ' · cookies OFF'}`],
    ['Bag', '…'],
    ['Shopify locates you in', '…'],
    ['Checked', new Date().toLocaleString()]
  ];
  const box = document.createElement('div');
  box.setAttribute('role', 'region');
  box.setAttribute('aria-label', 'Country check');
  box.style.cssText = 'position:fixed;left:8px;right:8px;top:8px;z-index:2147483647;max-width:560px;margin:0 auto;padding:12px 14px;background:#fff;color:#111;border:1px solid #111;font:13px/1.45 ui-monospace,Menlo,monospace;box-shadow:0 8px 30px rgba(0,0,0,.18)';
  const render = () => {
    box.innerHTML = '';
    const title = document.createElement('p');
    title.style.cssText = 'margin:0 0 6px;font-weight:700';
    title.textContent = 'Country check';
    box.append(title);
    rows.forEach(([k, v]) => {
      const line = document.createElement('p');
      line.style.cssText = 'margin:0;word-break:break-word';
      line.textContent = `${k}: ${v}`;
      box.append(line);
    });
    const bar = document.createElement('p');
    bar.style.cssText = 'margin:8px 0 0;display:flex;gap:16px';
    [['Copy', () => navigator.clipboard && navigator.clipboard.writeText(rows.map(([k, v]) => `${k}: ${v}`).join('\n'))], ['Close', () => box.remove()]].forEach(([label, fn]) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.textContent = label;
      b.style.cssText = 'min-height:44px;padding:0 4px;background:none;border:0;border-bottom:1px solid #111;font:inherit;color:#111;cursor:pointer';
      b.addEventListener('click', fn);
      bar.append(b);
    });
    box.append(bar);
  };
  const set = (key, value) => { rows.find((r) => r[0] === key)[1] = value; render(); };
  render();
  document.body.append(box);
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json())
    .then((c) => set('Bag', `${c.currency} · ${c.item_count} piece(s)`)).catch(() => set('Bag', 'unavailable'));
  fetch('/browsing_context_suggestions.json').then((r) => r.json())
    .then((d) => set('Shopify locates you in', (d.detected_values && d.detected_values.country_name) || 'unknown')).catch(() => set('Shopify locates you in', 'unavailable'));
})();

(() => {
  const footer = document.querySelector('.site-footer');
  if (!footer) return;

  const narrow = window.matchMedia('(max-width: 989px)');
  const groups = Array.from(footer.querySelectorAll('[data-footer-group]'));

  const fold = (group) => {
    const title = group.querySelector('[data-footer-group-title]');
    const panel = group.querySelector('[data-footer-group-panel]');
    if (!title || !panel || title.querySelector('button')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'site-footer__group-toggle';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', panel.id);
    button.textContent = title.textContent.trim();
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      group.classList.toggle('is-open', open);
    });
    title.textContent = '';
    title.append(button);
    group.classList.add('is-collapsible');
  };

  const unfold = (group) => {
    const title = group.querySelector('[data-footer-group-title]');
    const button = title && title.querySelector('button');
    if (!button) return;
    title.textContent = button.textContent;
    group.classList.remove('is-collapsible', 'is-open');
  };

  const apply = () => groups.forEach(narrow.matches ? fold : unfold);
  apply();
  narrow.addEventListener('change', apply);

  // Shipping country (and with it the currency): a new choice reloads the
  // page in the new currency. A page shown again from the browser's history
  // (Back, or the back-forward cache on phones) keeps the prices it was built
  // with, and browsers bring back the old choice in the list: put the list
  // back to the country the page is priced in, and reload the page if the
  // country has changed since it was built.
  const country = footer.querySelector('[data-footer-country]');
  const countryValue = footer.querySelector('[data-footer-country-value]');
  const form = country && country.form;
  if (form) {
    const current = form.dataset.current || country.value;
    const currentLabel = countryValue ? countryValue.textContent : '';
    const status = form.querySelector('[data-footer-country-status]');
    const chosen = () => (document.cookie.match(/(?:^|;\s*)localization=([A-Za-z]{2})/) || [])[1] || '';
    let timer = 0;

    const settle = () => {
      clearTimeout(timer);
      form.classList.remove('is-updating');
      form.removeAttribute('aria-busy');
      country.value = current;
      if (countryValue) countryValue.textContent = currentLabel;
    };

    form.classList.add('is-auto');

    window.addEventListener('pageshow', () => {
      const now = chosen().toUpperCase();
      if (now && current && now !== current.toUpperCase()) {
        // Once per page and country, so an unavailable country can't loop.
        const key = `ldj:country-reload:${location.pathname}`;
        let done = now;
        try {
          done = sessionStorage.getItem(key) || '';
          sessionStorage.setItem(key, now);
        } catch (error) {
          done = now;
        }
        if (done !== now) {
          window.location.reload();
          return;
        }
      }
      settle();
      if (status) status.textContent = '';
    });

    window.addEventListener('pagehide', () => clearTimeout(timer));

    country.addEventListener('change', () => {
      if (country.value === current) return;
      const label = country.selectedOptions[0]?.textContent.trim() || '';
      if (countryValue) countryValue.textContent = label;
      form.classList.add('is-updating');
      form.setAttribute('aria-busy', 'true');
      if (status) status.textContent = `Updating prices for ${label}…`;
      form.submit();
      // Offline or blocked: put the list back and say so.
      timer = setTimeout(() => {
        settle();
        if (status) status.textContent = 'Prices couldn’t be updated. Please try again.';
      }, 15000);
    });
  }
})();
